export default __webpack_public_path__ + "static/media/vue.17c4554a.jpeg";